import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useEnquiryModal } from "./EnquiryModal";
import { HiOutlineHomeModern, HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { FiTrendingUp, FiGrid, FiDollarSign, FiGlobe, FiMap, FiShield, FiCreditCard, FiUser, FiBarChart2, FiSun } from "react-icons/fi";
import { SlGlobe } from "react-icons/sl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useNavigate } from "react-router-dom";
import { Projects } from "./Projects";
import { FaBed, FaDollarSign } from "react-icons/fa";
import { useLeadForm } from "../hooks/useLeadForm";
import FooterMain from "./FooterMain";

function BrochureButton({ isScrolled, onClick, className = '', variant = 'default' }) {
  const isMobileMenu = variant === 'mobile';
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 border px-4 py-2 rounded-md font-bold shadow-md hover:shadow-lg transition ${className} ${isMobileMenu
        ? 'bg-transparent border-black text-black' // ✅ Mobile override
        : isScrolled
          ? 'bg-white border-gray-300 text-black hover:bg-sky-600/40'
          : 'bg-transparent border-white text-white hover:bg-white/20'
        }`}
    >
      <span
        className={`text-sm sm:text-base uppercase ${isMobileMenu ? 'text-[#003153]' : isScrolled ? 'text-[#003153]' : 'text-white'
          }`}
      >
        Get An Instant Call Back{' '}
      </span>{' '}
    </button>
  );
}


const stats = [
  {
    icon: <HiOutlineHomeModern className="w-14 h-14 text-gray-700" />,
    title: "Over 76000",
    desc: "Units Delivered",
  },
  {
    icon: < HiOutlineBuildingOffice2 className="w-14 h-14 text-gray-700" />,
    title: "More than 43,500",
    desc: "Units Under Development",
  },
  {
    icon: <FiTrendingUp className="w-14 h-14 text-gray-700" />,
    title: "36+ Markets",
    desc: "Covered Globally",
  },
  {
    icon: <SlGlobe className="w-14 h-14 text-gray-700" />,
    title: "62 New Projects",
    desc: "Launched in 2024",
  },
];

const testimonials = [
  {
    icon: <FiDollarSign className="w-12 h-12 text-gray-700" />,
    title: "Tax-Free Income",
    desc: "Enjoy rental yields without income tax, maximising your overall return on investment.",
  },
  {
    icon: <FiTrendingUp className="w-12 h-12 text-gray-700" />,
    title: "High ROI Potential",
    desc: "UAE consistently ranks among the top cities for property value growth and rental yields.",
  },
  {
    icon: <FiGlobe className="w-12 h-12 text-gray-700" />,
    title: "World-Class Infrastructure",
    desc: "Features advanced transport, healthcare, and education systems supporting long-term quality living.",
  },
  {
    icon: <FiMap className="w-12 h-12 text-gray-700" />,
    title: "Strategic Location",
    desc: "Acts as a global hub connecting East and West with unmatched accessibility.",
  },
  {
    icon: <FiShield className="w-12 h-12 text-gray-700" />,
    title: "Safe & Stable",
    desc: "Political stability and strong regulations create a secure investment environment.",
  },
  {
    icon: <FiCreditCard className="w-12 h-12 text-gray-700" />,
    title: "Luxury Lifestyle",
    desc: "Home to iconic landmarks, shopping malls, beaches, and leisure destinations.",
  },
  {
    icon: <FiUser className="w-12 h-12 text-gray-700" />,
    title: "Residency Benefits",
    desc: "Property ownership can qualify investors for long-term residency visas.",
  },
  {
    icon: <FiBarChart2 className="w-12 h-12 text-gray-700" />,
    title: "Strong Tourism Sector",
    desc: "Attracts millions annually, boosting short-term rental demand and profitability.",
  },
  {
    icon: <FiSun className="w-12 h-12 text-gray-700" />,
    title: "Year-Round Sunshine",
    desc: "Favourable climate supports an active, outdoor-oriented lifestyle and tourism appeal.",
  },
];

export default function HomePage() {
  const { openModal } = useEnquiryModal();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleCardClick = (property) => {
    navigate(`/property/${property.url}`, { state: property });
  };

  const images = [
    "../Assets/main_banner.jpg",
  ];
  const handleMobileEnquiry = () => {
    sessionStorage.setItem("goBackAfterClose", "true"); // ✅ Flag store
    openModal();
  };

  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [currentImage, setCurrentImage] = useState(0);
  const {
    phone,
    setPhone,
    dialCode,
    isoCode,
    loading,
    success,
    setSuccess,
    submitLead,
    setDialCode,
    setIsoCode,
    setNumberWithoutCountryCode
  } = useLeadForm();

  const [consentChecked, setConsentChecked] = useState(true);
  // const [errors, setErrors] = useState({ name: "", phone: "", email: "", message: "" });
  const [errors, setErrors] = useState({ name: "", phone: "", email: "" });

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const name = e.target.name.value.trim();
    const email = e.target.email.value.trim();
    // const message = e.target.message.value.trim();
    const cleanedPhone = phone ? phone.replace(/\D/g, "") : "";

    const newErrors = { name: "", phone: "", email: "" };
    // const newErrors = { name: "", phone: "", email: "", message: "" };

    // ✅ Name validation
    if (!name) {
      newErrors.name = "Name is required";
    }
    // ✅ Email validation
    if (!email) {
      newErrors.email = "Email is required";
    }

    // ✅ Phone validation (strong)
    if (!cleanedPhone) {
      newErrors.phone = "Phone number is required";
    }
    // Allow country code but ensure at least 8 digits total (including code)
    else if (cleanedPhone.length < 8) {
      newErrors.phone = "Please enter a valid phone number";
    }

    // ✅ Message validation      
    // if (!message) {
    //   newErrors.message = "Message is required";
    // }

    // Stop form if errors exist
    // if (newErrors.name || newErrors.phone || newErrors.email || newErrors.message) {
    if (newErrors.name || newErrors.phone || newErrors.email) {
      setErrors(newErrors);
      return;
    }

    // ✅ No errors — clear errors and submit
    // setErrors({ name: "", phone: "", email: "", message: "" });
    // const formData = { name, email, phone: cleanedPhone, message };
    setErrors({ name: "", phone: "", email: "" });
    const formData = { name, email, phone: cleanedPhone };

    const result = await submitLead(formData, e?.target);
    if (result) {
      e.target.reset();
      setConsentChecked(false);
      navigate("/thankyou.html");
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000); // 🔁 Change image every 4 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <>
      {/* <NavbarMain /> */}
      <div className="overflow-x-hidden">
        {' '}
        {/* Tailwind CSS CDN */}{' '}
        <script src="https://cdn.tailwindcss.com"></script>
        {/* Font Awesome for icons */}{' '}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
        <nav
          className={`fixed top-0 left-0 w-full z-50 p-2 md:px-20 transition-all duration-300 ${isScrolled
            ? 'bg-white shadow-md text-sky-900'
            : 'bg-transparent text-white'
            }`}
        >
          <div className="container max-w-7xl mx-auto flex md:items-center justify-between gap-2 lg:gap-0 px-4 lg:px-20 py-1">
            {/* <div className="space-x-8 flex items-center"> */}
            {/* Desktop Menu */}{' '}
            <div className="space-x-4 hidden md:flex md:justify-between md:items-center gap-6 font-semibold text-md">
              {/* <div className='hidden md:flex items-center gap-6 font-semibold text-md'> */}
              {' '}
              {[
                { id: '#', label: 'Why UAE' },
                { id: '#about', label: 'About' },
                { id: '#projects', label: 'Projects' },
                { id: '#map', label: 'Map' },
                { id: '#contact', label: 'Contact' },
              ].map((item) => (
                <a
                  key={item.id}
                  href={item.id}
                  className={`transition-colors duration-300 ${isScrolled
                    ? 'hover:text-black'
                    : 'hover:text-black'
                    }`}
                >
                  {' '}
                  {item.label}{' '}
                </a>
              ))}
              {/* </div> */}
            </div>{' '}
            <div className="hidden md:flex">
              {/* 🔥 Animated Download Brochure Button */}{' '}
              <BrochureButton className="hidden md:flex"
                isScrolled={isScrolled}
                onClick={openModal}
              />{' '}
            </div>
            {/* </div> */}
            {/* Mobile Menu Toggle */}{' '}
            {/* LEFT SIDE LOGO */}
            <div className="md:hidden justify-left">
              {/* <img
                src="../Assets/emaar_logo.png"  // 👈 tamaro logo path
                alt="Alef Logo"
                className="h-8 md:h-10 object-contain"
              /> */}
            </div>
            <div className="md:hidden justify-right right-4">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-[#000000] focus:outline-none"
              >
                <svg
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {' '}
                  {isMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16m-7 6h7"
                    />
                  )}{' '}
                </svg>{' '}
              </button>{' '}
            </div>{' '}
          </div>
          {/* Mobile Menu */}{' '}
          <div
            className={`fixed inset-0 z-40 bg-white transform transition-transform duration-300 ease-in-out ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'
              } lg:hidden p-8 pt-16`}
          >
            <div className="flex flex-col space-y-4 text-xl text-[#003153] text-center font-semibold">
              {' '}
              {[
                { id: '#', label: 'Why UAE' },
                { id: '#about', label: 'About' },
                { id: '#projects', label: 'Projects' },
                { id: '#map', label: 'Map' },
                { id: '#contact', label: 'Contact' },
              ].map((item) => (
                <a
                  key={item.id}
                  href={item.id}
                  className="py-2 hover:text-white"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {' '}
                  {item.label}{' '}
                </a>
              ))}
              {/* 🔥 Mobile Animated Button */}{' '}
              <BrochureButton
                isScrolled={isScrolled}
                onClick={handleMobileEnquiry}
                variant="mobile"
                className="mx-auto "
              />
            </div>{' '}
          </div>{' '}
        </nav>
      </div>

      {/* Home Section */}
      <section id="" className="relative h-screen w-full flex flex-col items-center justify-center text-white overflow-hidden">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Banner ${index + 1}`}
            className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000 ease-in-out ${index === currentImage ? "opacity-100" : "opacity-0"
              }`}
            style={{
              objectPosition:
                window.innerWidth < 768
                  ? "55% center" // mobile → thodu center ma
                  : "65% 35%", // desktop → thodu right side
              transform: "scale(1.03)", // light zoom for natural coverage
            }}
          />
        ))}

        {/* Overlay for better text visibility */}
        <div className="absolute inset-0 bg-black/40" />

        {/* Content */}
        <div className="relative z-10 text-center lg:text-start md:max-w-full max-w-full px-4 lg:px-0">
          <p className="text-md md:text-lg tracking-wide mb-4">
            Benchmark in Luxury Living
          </p>
          <h1 className="text-2xl md:text-7xl md:w-[900px] font-bold mb-4">
            ALEF Luxury Homes From AED 860K
          </h1>
          <p className="text-md md:text-2xl">
            SITTING THE STANDARD FOR LUXURY HOUSING IN UAE
          </p>
          <button
            onClick={openModal}
            className="mt-6 px-6 py-3 bg-transparent border-2 border-white text-white hover:bg-white/20 rounded-lg text-sm md:text-base font-semibold transition-colors duration-300"
          >
            Get Priority Access to Projects
          </button>
        </div>

        {/* Scroll Down Arrow */}
        <a
          href="#about"
          className="absolute items-center justify-center bottom-6 -translate-x-1/2 animate-bounce z-10"
        >
          <i className="ri-arrow-down-circle-fill text-[#ffffff] text-5xl"></i>
        </a>
      </section>

      {/* <AboutUs /> */}
      <section id="about" className="bg-gray-100 lg:py-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-6 sm:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4">
            <div className="text-black text-left">
              <h2 className="text-md md:text-lg font-semibold mb-4">
                Trusted by Investors
              </h2>
              <h2 className="text-2xl md:text-4xl font-bold mb-4">
                Why Alef Group
              </h2>
              <p className="text-md md:text-lg mb-4 leading-relaxed ">
                Alef Group has been shaping the future of Sharjah through thoughtfully planned lifestyle communities and destinations. With a people-first approach, Alef combines purposeful design, innovation, heritage and quality to create places designed not just to live in, but to experience.
              </p>
              <p className="text-md md:text-lg mb-4 leading-relaxed ">
                From walkable urban communities to nature-inspired villa developments and waterfront residences, Alef continues to contribute to Sharjah's evolution as a modern lifestyle destination.
              </p>
              <button onClick={openModal} className="px-6 py-3 bg-sky-600 text-white rounded-lg text-sm md:text-base font-semibold hover:bg-sky-800 transition-colors duration-300 animate-pulse">
                Download Investment Guide
              </button>
            </div>
            <div className="flex items-center justify-center">
              {/* Grid */}
              <div className="grid grid-cols-2 gap-4">
                {stats.map((item, index) => (
                  <div
                    key={index}
                    className="bg-transparent p-4 flex flex-col"
                  >
                    <div className="mb-2">{item.icon}</div>
                    <h3 className="font-semibold text-black mb-2 text-lg md:text-3xl">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <PricingComponent /> */}
      <section id="projects" className="bg-gray-200 lg:py-0 ">
        <div id="#projects" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-6 sm:py-20">
          {/* Header (Heading only on top for all views) */}
          <div className="mb-4 sm:mb-6">
            <h2 className="text-sm mb-2 sm:text-md md:text-lg font-bold text-[#000000]">
              Newly Launched
            </h2>
            <h2 className="mb-2 text-2xl sm:text-3xl md:text-5xl font-bold text-[#000000] text-start sm:text-left">
              Discover Alef’s Upcoming Projects
            </h2>
            <p className="text-md md:text-lg leading-relaxed ">
              Explore extraordinary homes crafted by the master developer across UAE.
            </p>
          </div>

          <Swiper
            modules={[Autoplay, Navigation]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            // pagination={{ clickable: true }}
            navigation={true}
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 2 },
            }}
          >
            {Projects.map((p) => {

              // --- Types compute logic ---
              let types = [];
              if (p.type) {
                if (p.type.includes("&")) {
                  types = p.type.split("&").map(t => t.trim());
                } else {
                  types.push(p.type);
                }
              }

              return (
                <SwiperSlide key={p.id}>
                  <div
                    key={p.id}
                    onClick={() => handleCardClick(p)}
                    className="cursor-pointer bg-white rounded-xl overflow-hidden shadow hover:shadow-lg transition transform hover:-translate-y-1"
                  >
                    <div className="relative">
                      <img
                        src={p.image}
                        alt={p.title}
                        className="w-full h-60 md:h-96 object-cover hover:scale-110 transition-transform duration-300"
                      />

                      <div className="absolute flex flex-col top-2 left-2 gap-2">

                        <div className="flex gap-2 flex-wrap">
                          {types.map((t, i) => (
                            <span
                              key={i}
                              className="bg-white text-sky-600 text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap"
                            >
                              {t}
                            </span>
                          ))}
                        </div>

                        <span className="bg-sky-600 text-white text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap inline-block max-w-[116px] overflow-hidden text-ellipsis">
                          {p.plan}
                        </span>
                      </div>
                    </div>

                    <div className="p-5">
                      {/* <h3 className=" text-3xl leading-[32px] font-semibold text-[#003153] mb-3 ">{p.price}</h3> */}
                      <p className="text-3xl mb-4 font-semibold">{p.title}</p>
                      <div className="hidden md:flex flex-row items-center justify-between gap-2 mb-2">
                        <div className="flex flex-row items-center">
                          <FiGrid size={20} className="mr-2" />
                          <h4 className="text-md">{p.area}</h4>
                        </div>
                        <div className="flex flex-row items-center">
                          <FaBed size={20} className="mr-2" />
                          <h4 className="text-md">{p.bed}</h4>
                        </div>
                        <div className="flex flex-row items-center">
                          <FaDollarSign size={20} className="mr-2" />
                          <h4 className="text-md">{p.pricePerSqft}</h4>
                        </div>
                      </div>
                      {/* Mobile view */}
                      <div className="md:hidden flex flex-row items-center justify-between gap-2 mb-2">
                        <div className="flex flex-row items-center">
                          <FiGrid size={20} className="mr-2" />
                          <h4 className="text-md">{p.area}</h4>
                        </div>
                        <div className="flex flex-row items-center">
                          <FaBed size={20} className="mr-2" />
                          <h4 className="text-md">{p.bed}</h4>
                        </div>
                      </div>
                      <div className="flex flex-row items-center mb-2 md:hidden">
                        <FaDollarSign size={20} className="mr-2" />
                        <h4 className="text-md">{p.pricePerSqft}</h4>
                      </div>
                      {/* <h2 className="text-md flex mb-4 items-center text-black">By {p.developer}</h2> */}
                      <p className="text-[#003153] text-sm flex items-center">
                        <i className="fa-solid text-[#003153] fa-location-dot mr-1"></i> {p.location}
                      </p>

                      <div className="flex md:flex-row flex-col gap-4 mt-4">
                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // card click prevent
                            openModal({
                              projectTitle: p.project_name,   // THIS IS IMPORTANT
                              projectId: p.id,
                            });
                          }}
                          className="w-full bg-sky-600 text-white border-sky-600 border-2 font-semibold py-2 hover:text-sky-600 rounded-md hover:bg-white transition">
                          DOWNLOAD BROCHURE
                        </button>
                        <button onClick={() => handleCardClick(p)} className="w-full border-2 border-sky-600 hover:text-white text-sky-600 font-semibold py-2 rounded-md hover:bg-sky-600 transition">
                          LEARN MORE
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section >

      {/* <Testimonials /> */}
      <section className="bg-gray-100 lg:py-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-6 sm:py-20">
          <h2 className="text-md md:text-lg font-semibold mb-2">
            Opportunity Awaits
          </h2>
          <h2 className="text-2xl md:text-5xl font-bold mb-10">
            Why Invest in UAE?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg hover:shadow-xl p-6 flex flex-col"
              >
                <div className="flex flex-col md:flex-row items-center gap-4 mb-2">
                  <div className="mb-2">{item.icon}</div>
                  <h3 className="text-black mb-2 text-lg md:text-2xl">
                    {item.title}
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map section */}
      <section id="map" className="bg-gray-200 lg:py-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-6 sm:pt-20">
          <h2 className="text-md md:text-lg font-semibold mb-2">
            Details
          </h2>
          <h2 className="text-2xl md:text-5xl font-bold mb-6">
            UAE Map
          </h2>
        </div>
        <img
          src="../Assets/Map.jpg"
          alt="Alef Global Presence Map"
          className="w-full h-auto h-auto lg:max-h-[600px] rounded-lg shadow-md"
        />
      </section>

      {/* <Footer /> */}
      <div>
        <footer id="contact" className="w-full bg-blue-50 p-4 sm:p-8 lg:p-20">
          <div className="container mx-auto">
            {/* Desktop Footer */}
            <div className="hidden lg:flex border-2 rounded border-sky-600 bg-white p-16 flex-col items-center">
              <h2 className="text-black text-2xl md:text-5xl font-bold mb-2">Next Masterpiece is Launching Soon!</h2>
              <p className="text-black text-center mb-8">Fill out the form to gain early access to information about Alef projects to maximise your returns.</p>
              <form
                onSubmit={handleFormSubmit}
                className="flex items-end justify-center space-x-4 w-full mb-6 max-w-5xl"
              >
                {/* Name input */}
                <div className="flex-1 flex flex-col relative">
                  <label className="text-black mb-1 text-sm font-semibold">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    className="h-[48px] p-3 rounded-lg bg-white border-2 border-sky-600 focus:border-sky-600 outline-none w-full"
                    required
                  />
                  {errors.name && (
                    <span className="absolute bottom-[-18px] text-black text-sm mt-1">{errors.name}</span>
                  )}
                </div>

                {/* Phone input */}
                <div className="flex-1 flex flex-col relative">
                  <label className="text-black mb-1 text-sm font-semibold">
                    Phone Number
                  </label>
                  <PhoneInput
                    country={isoCode || "in"}
                    value={phone}
                    onChange={(value, country) => {
                      setPhone(value);
                      setDialCode(`${country.dialCode}`);
                      setIsoCode(country.countryCode);
                      setNumberWithoutCountryCode(value.replace(country.dialCode, ""));
                    }}
                    inputProps={{ name: "phone", required: true }}
                    containerClass="w-full"
                    inputClass="!w-full !h-[48px] !pl-12 !pr-3 !rounded-lg !bg-white !text-black !border-2 !border-sky-600 focus:!border-sky-600 !outline-none placeholder:!text-gray-400"
                    buttonClass="!h-[48px] !flex !items-center !justify-center !bg-gray-300 !border-none !rounded-l-lg "
                    dropdownClass="!bg-white !text-black"
                    searchClass="!bg-white !text-black"
                    enableSearch={true}
                    placeholder="Enter phone number"
                    required
                  />
                  {errors.phone && (
                    <span className="absolute bottom-[-18px] text-black text-sm mt-1">{errors.phone}</span>
                  )}
                </div>

                <div className="flex-1 flex flex-col">
                  <label className="text-black mb-1 text-sm font-semibold">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="h-[48px] p-3 rounded-lg bg-white border-2 border-sky-600 focus:border-sky-600 outline-none w-full"
                    required
                  />
                  {errors.email && (
                    <span className="absolute bottom-[-18px] text-black text-sm mt-1">{errors.email}</span>
                  )}
                </div>
              </form>
              <button
                type="submit"
                className="bg-sky-600 max-w-2xl text-lg text-[#ffffff] border-2 border-sky-600 px-8 py-2.5 rounded-lg font-bold hover:text-sky-600 hover:bg-white transition-colors h-fit"
                disabled={loading}
              >
                {loading ? "Submitting..." : "SUBSCRIBE NOW"}
              </button>
            </div>

            {/* Mobile/Tablet Footer */}
            <div className="lg:hidden mb-5 flex flex-col items-center space-y-4">
              <h2 className="text-black mt-5 text-2xl font-bold">ENQUIRE NOW</h2>
              <form onSubmit={handleFormSubmit} className="w-full space-y-4">
                <div className="flex flex-col">
                  <label className="text-black mb-1 text-sm font-semibold">Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    className="h-[48px] w-full p-3 rounded-lg bg-white border-2 border-sky-600 focus:border-sky-600 outline-none"
                    required
                  />
                  {errors.name && (
                    <span className="text-black text-sm mt-1">{errors.name}</span>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-black mb-1 text-sm font-semibold">Phone Number</label>
                  <PhoneInput
                    country={isoCode || "in"}
                    value={phone}
                    onChange={(value, country) => {
                      setPhone(value);
                      setDialCode(`${country.dialCode}`);
                      setIsoCode(country.countryCode);
                      setNumberWithoutCountryCode(value.replace(country.dialCode, ""));
                    }}
                    inputProps={{ name: "phone", required: true }}
                    containerClass="w-full "   // ✅ relative so dropdown positions properly
                    inputClass="!w-full !bg-white !text-black !py-3 !pl-12 !pr-3 !rounded-md !border-2 !border-sky-600 focus:!border-sky-600 !outline-none"
                    buttonClass="!bg-gray-800 !border-none !rounded-l-md !bg-gray-200"
                    dropdownClass="!bg-white !text-black "   // ✅ keep dropdown above !z-[9999] !absolute
                    searchClass="!bg-white !text-black"
                    enableSearch={true}
                    required
                  />
                  {errors.phone && (
                    <span className="text-black text-sm mt-1">{errors.phone}</span>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-black mb-1 text-sm font-semibold">Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="h-[48px] w-full p-3 rounded-lg bg-white border-2 border-sky-600 focus:border-sky-600 outline-none"
                    required
                  />
                  {errors.email && (
                    <span className="text-black text-sm mt-1">{errors.email}</span>
                  )}
                </div>
              </form>
              <button
                type="submit"
                className="bg-sky-600 w-full text-lg text-[#ffffff] border-2 border-sky-600 px-8 py-2.5 rounded-lg font-bold hover:text-sky-600 hover:bg-white transition-colors h-fit"
                disabled={loading}
              >
                {loading ? "Submitting..." : "SUBSCRIBE NOW"}
              </button>
            </div>
          </div>
        </footer>
      </div>

      <FooterMain />
    </>
  );
}
